import React from "react";
import { Link } from "react-router-dom";
import { FaCalendarAlt, FaClock, FaUser } from "react-icons/fa";

export default function BlogFeatured({ blog }) {
  if (!blog) return null;

  const formattedDate = blog.publishedAt
    ? new Date(blog.publishedAt).toLocaleDateString("en-US", {
        year: "numeric",
        month: "short",
        day: "numeric",
      })
    : "";

  return (
    <article className="blog-featured">
      <div className="blog-featured-inner">
        <div className="blog-featured-image-wrapper">
          <Link to={`/blog/${blog.slug}`}>
            {blog.coverImage ? (
              <img
                src={blog.coverImage}
                alt={blog.title}
                className="blog-featured-image"
                loading="lazy"
              />
            ) : (
              <div className="blog-featured-image-placeholder">
                <span>No Image</span>
              </div>
            )}
          </Link>
        </div>
        <div className="blog-featured-content">
          <h2 className="blog-featured-title">
            <Link to={`/blog/${blog.slug}`}>{blog.title}</Link>
          </h2>
          <div className="blog-featured-meta">
            <span>
              <FaCalendarAlt /> {formattedDate}
            </span>
            <span>
              <FaClock /> {blog.readingTime}
            </span>
            {blog.author?.name && (
              <span>
                <FaUser /> {blog.author.name}
              </span>
            )}
          </div>
          {blog.excerpt && (
            <p className="blog-featured-excerpt">{blog.excerpt}</p>
          )}
          <Link to={`/blog/${blog.slug}`} className="blog-featured-read-more">
            Read More →
          </Link>
        </div>
      </div>
    </article>
  );
}
